import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {DepotsService} from "../../services/depots-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {ScheduleDialogService} from "../../../schedule/services/schedule-dialog.service";
import {ScheduleService} from "../../../schedule/services/schedule-service.service";

export type DepotTimeWindowMode = 'OFF' | 'SINGLE' | 'PROGRAM';

export class depotScheduleViewCtrl implements IController {
  depot: any;
  from: any;
  to: any;
  schedule: any;
  selectedTemplate: any;
  programs: any;

  private timeWindowMode: DepotTimeWindowMode;
  private selectedProgram: any;
  private dateFormat: any;
  private columnFormat: any;

  private views: any;
  private canCreate: boolean;
  private canUpdate: boolean;
  private canDelete: boolean;
  private events: any;

  constructor(private scheduleDialogService: ScheduleDialogService, private confirmDialogService: ConfirmDialogService, private splitService: SplitService, private $q: IQService,
              private commonsDialogService: CommonsDialogService, private IAMPermissions, private $log, private scheduleService: ScheduleService,
              private $filter, private moment, private depotsService: DepotsService, private commonsService: CommonsService) {

  }

  $onInit() {
    this.timeWindowMode = this._resolveTimeWindowMode(this.depot);
    this.selectedProgram = _.find(this.programs, (p) => {
      return p.id === 'SameDay';
    }) || this.programs[0];

    this.dateFormat = this.splitService.getDateAndTimeConfig().long;
    this.columnFormat = 'ddd ' + this.dateFormat;

    // ctrl.dateFormat = splitService.getDateAndTimeConfig().long;
    // ctrl.firstDay = splitService.getDateAndTimeConfig().firstDay;
    this.views = ['agendaWeek','agendaDay'];

    this.canCreate = this.IAMPermissions.hasPermission('depots.schedule.create');
    this.canUpdate = this.IAMPermissions.hasPermission('depots.schedule.update');
    this.canDelete = this.IAMPermissions.hasPermission('depots.schedule.delete');

    if (!this.schedule) {
      this.schedule = [];
    }

    this.events = [];
    this._initSchedule(this.depot.id, this.from, this.to, this.selectedProgram);

    // this.events = this._convertScheduleToEvent(this.schedule);
  }

  $onChanges(changes) {
    if (changes.depot && !changes.depot.isFirstChange()) {
      this._applyDepot(this.depot);
    }
  }

  onTimeWindowModeChange(mode: DepotTimeWindowMode) {
    const depotCopy = angular.copy(this.depot);
    Object.assign(depotCopy, this._modeToFlags(mode));

    this.depotsService.updateOne(depotCopy.id, depotCopy)
      .then((updatedDepot) => this._applyDepot(updatedDepot))
      .catch(() => this._applyDepot(this.depot));
  }

  onProgramTypeChange(selectedProgram) {
    this.selectedProgram = selectedProgram;
    this._initSchedule(this.depot.id, this.from, this.to, this.selectedProgram);
  }

  onClearSchedule($event) {
    this.confirmDialogService.confirm('Reset Schedule', 'Are you sure you want to reset this schedule?', $event)
      .then(() => {
        this._clearDepotSchedule();
      })
  }

  onCreateSchedule($event, from, to) {
    this.scheduleDialogService.create($event, from, to, _.get(this.selectedTemplate, 'zoneId'))
      .then((scheduleToCreate) => {
        this._createSchedule(scheduleToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onEditSchedule(scheduleEvent, needToEdit, revertFunc, $event) {
    let eventInstanceFromDate;
    let changeType;
    const scheduleRef = scheduleEvent.dataRef;
    // var functionRef = scheduleRef.schedule.freq ? scheduleDialogService.selectChangeType($event) : $q.when()
    const functionRef = (scheduleRef.holderType === 'DEPOT' && scheduleRef.schedule.freq) ? this.scheduleDialogService.selectChangeType($event) : this.$q.when();

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        let eventInstanceToDate;
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceFromDate = scheduleEvent.start.valueOf();
          eventInstanceToDate = scheduleEvent.end.valueOf();
        }

        return needToEdit ? this.scheduleDialogService.edit($event, scheduleRef, eventInstanceFromDate, eventInstanceToDate): this.$q.when({schedule: scheduleRef});
      })
      .then((editedSchedule) => {
        this._updateOneSchedule(editedSchedule.schedule, changeType, eventInstanceFromDate);
      })
      .catch(() => {
        if (revertFunc) {
          revertFunc();
        }
        this.$log.info('Dialog Closed');
      });
  }

  onDeleteSchedule(scheduleEvent, $event) {
    let eventInstanceDate;
    let changeType;
    const scheduleRef = scheduleEvent.dataRef;
    const functionRef = (scheduleRef.holderType === 'DEPOT' && scheduleRef.schedule.freq) ? this.scheduleDialogService.selectChangeType($event) : this.$q.when();

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceDate = scheduleEvent.start.valueOf();
        }

        // if (changeType === 'ALL') {
        //     eventInstanceDate = scheduleRef.schedule.startTime;
        // }

        this._deleteSchedule(scheduleRef.id, changeType, eventInstanceDate);
        // _updateOneSchedule(editedSchedule, changeType, eventInstanceDate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onViewRender(start, end) {
    const currentStart = start.valueOf();
    const currentEnd = end.valueOf();

    if (this.from !== currentStart || this.to !== currentEnd) {
      this.from = currentStart;
      this.to = currentEnd;

      this._initSchedule(this.depot.id, currentStart, currentEnd, this.selectedProgram)
    }
  }

  onCalendarSelection(from, to, $event) {

    // If only clicked on calendar (less then an full hour)
    if (to.valueOf() - from.valueOf() <= 1800000) {
      return;
    }

    this.onCreateSchedule($event, from.valueOf(), to.valueOf());

    // var format = splitService.getDateAndTimeConfig().time,
    //     title = 'Create Schedule, ' + from.format(format) + ' - ' + to.format(format);
    //
    // ConfirmDialog.confirm(title, 'Are you sure you want to create a new schedule?', $event)
    //     .then(function() {
    //         var scheduleToCreate = scheduleService.getSchedulePayload(from.valueOf(), to.valueOf(), from.valueOf());
    //         _createSchedule(scheduleToCreate);
    //     })
    //     .catch(function(error) {
    //         $log.info('Dialog Closed');
    //     })
  }

  onEventClick(event, $event) {

    if (this.moment(event.start).startOf('day').isBefore(this.moment().startOf('day'))) {
      return;
    }

    const actions = _.chain([
      {key: 'Edit', value: this.canUpdate},
      {key: 'Delete', value: this.canDelete}
    ])
      .filter((a) => {
        return a.value;
      })
      .map((a) => {
        return a.key
      })
      .value();

    this.commonsService.openActionPanel(actions, $event)
      .then((reason) => {
        if (reason === 'Edit') {
          this.onEditSchedule(event, true, undefined, $event)
        }
        if (reason === 'Delete') {
          this.onDeleteSchedule(event, $event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onEventChange(event, delta, revertFunc, $event) {

    const oneScheduleCopy = angular.copy(event);

    if (oneScheduleCopy.start.startOf('day').isBefore(this.moment().startOf('day'))) {
      revertFunc();
      return;
    }

    oneScheduleCopy.dataRef.schedule.startTime = event.start.valueOf();
    oneScheduleCopy.dataRef.schedule.endTime = event.end.valueOf();

    this.onEditSchedule(oneScheduleCopy, false, revertFunc, $event);
  }

  getHeight() {
    // var element = angular.element(document.querySelector('#content-container'));
    // return element[0].clientHeight;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _applyDepot(depot) {
    this.depot = depot;
    this.timeWindowMode = this._resolveTimeWindowMode(depot);
    this._initSchedule(depot.id, this.from, this.to, this.selectedProgram);
  }

  private _initSchedule(depotId, from, to, selectedProgram) {
    if (this.timeWindowMode === 'OFF') {
      this.schedule = [];
      this.events = [];
      return;
    }

    const programType = this.timeWindowMode === 'PROGRAM' ? _.get(selectedProgram, 'id') : undefined;

    this.scheduleService.getByDepotId(depotId, from, to, programType)
      .then((schedule) => {
        this.schedule = schedule;
        this.events = this._convertScheduleToEvent(schedule);
      })
  }

  private _createSchedule(schedule) {
    if (this.timeWindowMode === 'PROGRAM') {
      schedule.programType = _.get(this.selectedProgram, 'id');
    } else {
      delete schedule.programType;
    }
    this.scheduleService.createManyByDepotId([schedule], this.depot.id)
      .then((createdSchedule) => {
        this.schedule = this.schedule.concat(createdSchedule);
        this.events = this._convertScheduleToEvent(this.schedule);
      })
  }

  private _updateOneSchedule(schedule, type, eventInstanceDate) {

    if (this.timeWindowMode === 'PROGRAM') {
      if (!schedule.programType) {
        schedule.programType = _.get(this.selectedProgram, 'id');
      }
    } else {
      delete schedule.programType;
    }

    this.scheduleService.updateOneByDepotId(schedule, schedule.id, this.depot.id, type, eventInstanceDate)
      .then((updatedSchedule) => {
        this._initSchedule(this.depot.id, this.from, this.to, this.selectedProgram);
      })
  }

  private _deleteSchedule(scheduleId, type, eventInstanceDate) {
    this.scheduleService.deleteOneByDepotId(scheduleId, this.depot.id, type, eventInstanceDate)
      .then((deletedShift) => {
        this._initSchedule(this.depot.id, this.from, this.to, this.selectedProgram);
      })
  }

  private _clearDepotSchedule() {
    // return this.AgentsService.clearSchedule(this.depot.id)
    //   .then(() => {
    //     this.schedule = [];
    //     this.events = [];
    //     this.selectedTemplate = undefined;
    //   })
  }

  private _convertScheduleToEvent(schedule) {

    if (!schedule) {
      return [];
    }

    return this.scheduleService.parseManyScheduleToEventsByRange(schedule, this.from, this.to, this.depot.id);
  }

  private _resolveTimeWindowMode(depot: any): DepotTimeWindowMode {
    if (!_.get(depot, 'considerDepotSchedule')) {
      return 'OFF';
    }
    return _.get(depot, 'useDefaultProgramSchedule') ? 'SINGLE' : 'PROGRAM';
  }

  private _modeToFlags(mode: DepotTimeWindowMode): { considerDepotSchedule: boolean; useDefaultProgramSchedule: boolean; } {
    switch (mode) {
      case 'SINGLE':
        return {considerDepotSchedule: true, useDefaultProgramSchedule: true};
      case 'PROGRAM':
        return {considerDepotSchedule: true, useDefaultProgramSchedule: false};
      case 'OFF':
      default:
        return {considerDepotSchedule: false, useDefaultProgramSchedule: false};
    }
  }

}

angular
  .module('bringoz.admin.depots')
  .component('depotScheduleView', {
    bindings: {
      depot: '<',
      from: '<',
      to: '<',
      programs: '<'
    },
    template: require('./depot-schedule-view.html').default,
    controller: depotScheduleViewCtrl
  });
